import { TestBuyFollowUp } from "@coworker/types/lib/tasks/testbuy_followup";
import { useCallback } from "react";
import { useCreateTask } from "../../../hooks/TaskActions/useCreateTask";
import { useToggle } from "../../../hooks/useToggle";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import {
  useAddFollowUpTaskId as addFollowUpTaskIdPG,
  TESTBUY_ARTICLES_QUERY_KEY,
} from "../CommonComponents/Repositories/useArticleService";
import { useQueryClient } from "@tanstack/react-query";

export function useCreateTestbuyTask() {
  const { call: createTask } = useCreateTask();
  const [loading, toggleLoading] = useToggle(false);
  const navigate = useFixaNavigate();
  const queryClient = useQueryClient();

  const onCreateClick = useCallback(
    async (task: TestBuyFollowUp, articleKey: string, testbuyId: string) => {
      toggleLoading();

      try {
        // Create the task and retrieve its ID
        const createdTaskId = await createTask(task, task.images);

        // Ensure all parameters are available before calling addFollowUpTaskIdPG
        if (testbuyId && articleKey && createdTaskId) {
          await addFollowUpTaskIdPG(testbuyId, articleKey, createdTaskId);
        } else {
          console.error("Missing parameters: Cannot call addFollowUpTaskIdPG", {
            testbuyId,
            articleKey,
            createdTaskId,
          });
        }

        queryClient.removeQueries({
          queryKey: [TESTBUY_ARTICLES_QUERY_KEY],
        });
        // Navigate to the testbuy page
        navigate(`/testbuy/${testbuyId}`);
      } catch (error) {
        console.error("Error creating or linking the follow-up task:", error);
      } finally {
        // Ensure loading toggle is always called
        toggleLoading();
      }
    },
    [createTask, navigate, queryClient, toggleLoading]
  );

  return { loading, onCreateClick };
}
